import { render, staticRenderFns } from "./FlowDesign.vue?vue&type=template&id=b946071a&scoped=true"
import script from "./FlowDesign.vue?vue&type=script&lang=js"
export * from "./FlowDesign.vue?vue&type=script&lang=js"
import style0 from "./FlowDesign.vue?vue&type=style&index=0&id=b946071a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b946071a",
  null
  
)

export default component.exports